import DataTable from "../DataTables/DataTable";
import CircularImage from "../assests/CircularImage";
import { user_profile } from "../imagepath";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import StatusBadge from "../assests/StatusBadge";
import { useUserStatusToggle } from "../../hooks/users/useUserStatusToggle";
import ToggleUser from "../modals/ToggleUser";
import { useState } from "react";
import SideModal from "../modals/SideModal";
import UserDetails from "./UserDetails";
import { formatToDate } from "../configs/formatToDate";

function UserTable({ usersList, isLoading }) {
  const { mutate } = useUserStatusToggle();
  const [show, setShow] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [userDetails, setUserDetails] = useState({});
  const handleBlockUser = (id) => {
    mutate(id);
    setUserDetails({});
  };
  const handelBlockClick = (record) => {
    setUserDetails(record);
    setShow(true);
  };
  const handlePreview = (record) => {
    setUserDetails(record);
    setShowPreview(true);
  };
  const handleClose = () => {
    setShowPreview(false);
  };
  const columns = [
    {
      title: "USER NAME",
      dataIndex: "first_name",
      sorter: (a, b) =>
        a?.first_name &&
        b?.first_name &&
        a.first_name.localeCompare(b.first_name),
      render: (item, record) => (
        <div className="d-flex">
          <div>
            <CircularImage
              src={record?.profile_picture ?? user_profile}
              alt={item}
              size={40}
              fallback={user_profile}
            />
          </div>
          <div className="ms-2 table-profile">
            <h6>{record?.first_name}</h6>
            <p className="text-muted mb-0">{record.email}</p>
          </div>
        </div>
      ),
    },
    {
      title: "PHONE",
      dataIndex: "phone",
      // sorter: (a, b) => a.empid.length - b.empid.length,
    },
    {
      title: <div className="text-center">AGE</div>,
      dataIndex: "age",
      render: (item) => <div className="text-center">{item}</div>,
      // sorter: (a, b) => a.empid.length - b.empid.length,
    },
    {
      title: "STATUS",
      dataIndex: "is_active",
      filters: [
        { text: "active", value: true },
        { text: "blocked", value: false },
      ],
      onFilter: (value, record) => record.is_active === value,
      filterSearch: true,
      render: (item) => (
        <div>
          <StatusBadge status={item ? "active" : "blocked"} />
        </div>
      ),
    },
    {
      title: "GENDER",
      dataIndex: "gender",
    },
    {
      title: <div className="text-center">JOINING DATE</div>,
      dataIndex: "created_at",
      sorter: (a, b) =>
        new Date(a.created_at) - new Date(b.created_at),
      render: (item) => <div className="text-center">{formatToDate(item)}</div>,
    },
    {
      title: "",
      dataIndex: "",
      render: (item, record) => (
        <>
          <div className="text-end">
            <div className="dropdown dropdown-action">
              <Link
                to="#"
                className="action-icon dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="fas fa-ellipsis-v" />
              </Link>
              <div className="dropdown-menu dropdown-menu-end">
                <Link
                  className="dropdown-item"
                  to
                  onClick={() => handlePreview(record)}
                >
                  <i className="fa fa-eye m-r-5"></i>
                  <span className="ps-1">View</span>
                </Link>
                <Link
                  className="dropdown-item"
                  to
                  onClick={() => handelBlockClick(record)}
                >
                  {record?.is_active ? (
                    <span>
                      <i className="fa fa-user-slash m-r-5"></i> Block
                    </span>
                  ) : (
                    <span>
                      <i className="fa fa-user-check m-r-5"></i> Activate
                    </span>
                  )}
                </Link>
              </div>
            </div>
          </div>
        </>
      ),
    },
  ];
  return (
    <div className="mt-3">
      <DataTable columns={columns} data={usersList} loading={isLoading} />
      <ToggleUser
        show={show}
        setShow={setShow}
        title={userDetails?.first_name}
        status={userDetails?.is_active}
        handleStatusChange={handleBlockUser}
        userId={userDetails?.id}
      />
      <SideModal show={showPreview} handleClose={handleClose} title="">
        <UserDetails userDetails={userDetails} />
      </SideModal>
    </div>
  );
}

UserTable.propTypes = {
  usersList: PropTypes.array,
  isLoading: PropTypes.bool,
};

export default UserTable;
